<template>
  <v-card>
    <JSONDialog ref="dialog" @openMiniParser="openMiniParser" />

    <v-toolbar class="card-bar">
      <v-toolbar-title>Output</v-toolbar-title>

      <v-btn-toggle
        class="ml-12"
        v-model="outputType"
        tile
        color="deep-purple accent-3"
        group
      >
        <v-btn value="slices">
          Frames
        </v-btn>

        <v-btn value="operations">
          Operations
        </v-btn>
      </v-btn-toggle>

      <v-spacer />
    </v-toolbar>
    <ODataTable
      v-if="outputType == 'slices'"
      :spec="slicesSpec"
      :items="allFrames"
      @rowClicked="showRowDetails"
    />

    <ODataTable
      v-if="outputType == 'operations'"
      :spec="operationsSpec"
      :items="allOperations"
      @rowClicked="showRowDetails"
    />
  </v-card>
</template>

<script>
import InspectorStore from './InspectorStore'
import ODataTable from 'oderon-vue/cpts/ODataTable.vue'
import { brLongDateTime } from 'oderon-commons/src/formatters.js'
import JSONDialog from './JSONDialog.vue'
import moment from 'moment'
import {
  getOperationInfo,
  getFrameInfo
} from 'horus-parser/src/tools/get-info.mjs'
import brush from 'brush'

const ON = { labelColor: 'green', labelText: 'on-trip' }
const OFF = { labelColor: 'red', labelText: 'off-trip' }

function maybeRed(dt) {
  if (dt == null) return dt
  const d = moment().diff(dt, 'd')
  const f = brLongDateTime(dt)
  if (d < -1) return { style: { color: '#ff0000' }, value: f }
  if (d > 365) return { style: { color: '#ff0000' }, value: f }
  return f
}

export default {
  components: { ODataTable, JSONDialog },
  data() {
    return {
      outputType: 'slices',

      slicesSpec: [
        { t: 'Frame', d: 'type', w: 110 },
        { t: 'Ponteiro Início|', w: 100, d: 'startIndex' },
        { t: 'Tamanho (bytes)|', w: 100, d: 'length' },
        { t: 'Data/hora|', d: (row) => getTimestamp(row), f: maybeRed, w: 210 },
        { t: 'Info', d: (row) => getInfo(row) }
      ],

      operationsSpec: [
        {
          t: 'Origem',
          w: 100,
          d: (row) => (row.source == 'on' ? ON : OFF)
        },
        { t: 'Data/hora|', w: 250, d: (row) => getTimestamp(row), f: maybeRed },
        { t: 'Tipo', d: 'typeStr', w: 200 },
        { t: 'Info', d: (row) => getInfo(row) }
      ]
    }
  },
  computed: {
    allFrames() {
      return InspectorStore.allFrames
    },
    allOperations() {
      return InspectorStore.allOperations
    }
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.formattedBytes)
      this.$snack(`Copiado para a área de transferência`)
    },

    showRowDetails(row) {
      this.$refs.dialog.open(row)
    },

    openMiniParser({ frame }) {
      const bytes = InspectorStore.getFrameBytes(frame)
      const hexInput = brush.toHex(bytes, {
        prettyPrint: true,
        bytesPerLine: 32,
        groupSep: '',
        byteSep: ''
      })
      this.$emit('openMiniParser', { hexInput })
    }
  }
}

function getTimestamp(frame) {
  if (frame.header) return frame.header.timestamp
  if (frame.footer) return frame.footer.timestamp
  if (frame.event) return frame.event.timestamp
  if (frame.timestamp) return frame.timestamp
  return null
}

function getInfo(frame) {
  // é uma Operation
  if (frame.source != null) {
    return getOperationInfo(frame)
  }

  // é um Frame
  else {
    return getFrameInfo(frame)
  }
}
</script>

<style></style>
